// auto-generated by Typewriter template _enums.tst from PortCall.Models\CoordinationCards\CoordinationProviderCurrency.cs
export enum CoordinationProviderCurrency { 
    Current = 0,
    Deprecated = 10
}

export const CoordinationProviderCurrencyDisplayName : { [val : number] : string } = { 
    0: 'Current',
    10: 'Deprecated'
}

export const CoordinationProviderCurrencys : { Id : CoordinationProviderCurrency, Name : string }[] = [ 
    { Id: CoordinationProviderCurrency.Current, Name: 'Current' },
    { Id: CoordinationProviderCurrency.Deprecated, Name: 'Deprecated' }
]



// WEBPACK FOOTER //
// ./server/enums/CoordinationProviderCurrency.ts